import { createProvider } from '@nvision/services/data-provider';

import * as api from './api';
import { normalizeShipmentProductHazmat } from './normalize';

export const fetchShipmentProductHazmat = createProvider(api.fetchShipmentProductHazmat)
  .andThen((res) => normalizeShipmentProductHazmat(res))
  .andCatch((error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      console.warn('Fetch list aborted');
    } else {
      console.error('Fetch list was failed:', error);
    }
    throw error;
  });
